import { useTranslation } from 'react-i18next';
import { HeaderBreadcrumbsProps } from 'src/components/HeaderBreadcrumbs';
import { PageLayout } from 'src/components/app-components/PageLayout';
import { StyledLoading } from 'src/components/app-components/StyledLoading';
import { EnqueteAnswersListGridLayout } from '../components/pages/list/components/EnqueteAnswersListGridLayout';
import { useEnqueteAnswerRedirect } from '../hooks/useEnqueteAnswerRedirect';

export const EnqueteAnswerListPage = () => {
  const { t } = useTranslation();
  const { isLoading } = useEnqueteAnswerRedirect();

  const enqueteAnswersListTitle = t('enqueteAnswerList.pageTitle');
  const breadcrumbs: HeaderBreadcrumbsProps = {
    heading: enqueteAnswersListTitle,
    links: [{ name: 'TOP', href: '/top' }],
    activeLast: true,
  };

  if (isLoading) {
    return <StyledLoading isOpen={isLoading} />;
  }

  return (
    <PageLayout title={enqueteAnswersListTitle} breadcrumbs={breadcrumbs}>
      <EnqueteAnswersListGridLayout />
    </PageLayout>
  );
};
